/**
 * @generated SignedSource<<3c914b3583788f64b6e544a7a7becb54>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDimensions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_user">;
  readonly " $fragmentType": "SbRespRefineMenuFilterDimensions_user";
};
export type SbRespRefineMenuFilterDimensions_user$key = {
  readonly " $data"?: SbRespRefineMenuFilterDimensions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterDimensions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterDimensions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5c095c96fa002ff53f39d14e3317552f";

export default node;
